import React from "react";

const SummaryCardEl = ({
  setStatusFocused,
  statusFocused,
  status_id,
  data,
  title,
  qtyClassStyle,
  setFilterList,
  setInternFilterTypeList,
  qtyColorText,
  cardWidth,
  cardHeight,
  
}) => {
  
  
  const styles = {
    container: {
      backgroundColor: statusFocused == status_id ? "rgba(24,118,209,0.3)" : "",
      width: cardWidth ?? "",
      height: cardHeight ? cardHeight : "130px",
    },
    qtyStyle: {
      color: qtyColorText ? qtyColorText : "",
    },
   
  };

  return (
    <div
      className="col"
      type="button"
      onClick={() => {
        setStatusFocused(status_id);
        setFilterList(data);
        setInternFilterTypeList(data);
      }}
    >
      <div className="card shadow border-success" style={styles.container}>
        <div className="card-body">
          <div className={`display-3 `} style={styles.qtyStyle}>
            {data.length}
          </div>
           <div className=""><span class ="badge badge-soft-dark">  {title}</span></div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCardEl;
